import { ApiMatchEventIdGet200ResponseDataMatchStatisticsTotalsCompetitorsInnerPlayersInner } from '@/api/livescore/generated';
import { cn } from '@/utils/cn';
import { calculatePlayerRating } from '@/utils/ratePlayer';

type LivescorePlayerStatsProps = {
  className?: string;
} & (
  | {
      stats: ApiMatchEventIdGet200ResponseDataMatchStatisticsTotalsCompetitorsInnerPlayersInner['statistics'];
      position: string;
      rating?: never;
    }
  | {
      rating: number;
      position?: never;
      stats?: never;
    }
);

const LivescorePlayerStats = ({ position, stats, rating, className }: LivescorePlayerStatsProps) => {
  const ratingValue = rating ?? calculatePlayerRating(position, stats);
  return (
    <span
      className={cn(
        '!text-white px-[2.5px] py-[1.25px] font-bold text-[8.75px] rounded-[2.5px]',
        ratingValue >= 7.8
          ? 'bg-[#1C4DFF]'
          : ratingValue >= 7
          ? 'bg-[#06C000]'
          : ratingValue >= 6
          ? 'bg-[#FFA600]'
          : 'bg-[#FF0004]',
        className,
      )}
    >
      {ratingValue.toFixed(1)}
    </span>
  );
};

export default LivescorePlayerStats;
